<script>
import apiServices from "@/services/yungol-services";
export default {
  template: `<div class="buttons is-justify-end" style='width: 100%; height: 100%; margin: auto; margin-top: 2px'>
    <button class="button" :class="params.data.status ? 'is-dark' : 'is-grey'" v-on:click="switchStatus()">
          <span v-tooltip="params.data.status ? 'Deshabilitar' : 'Habilitar' + ' proceso'" class="icon">
            <i class="material-icons">{{ params.data.status ? 'toggle_on' : 'toggle_off' }}</i>
          </span>
    </button>
    <button class="button is-link" @click="selectedComp()">
        <span v-tooltip="'Crear Comparación'" class="icon">
          <i class="material-icons">compare_arrows</i>
        </span>
    </button>
    <button class="button is-success" v-on:click="editProcess()">
        <span v-tooltip="'Editar'" class="icon">
          <i class="material-icons">edit</i>
        </span>
    </button>
    <button class="button is-danger" v-on:click="deleteEmployee()">
        <span v-tooltip="'Eliminar'" class="icon">
          <i class="material-icons">delete_forever</i>
        </span>
    </button>
  </div>`,
  data() {
    return {
      params: this.$parent.params,
    };
  },
  methods: {
    // Actions
    editProcess() {
      this.$emit("editProcess", this.params.data);
    },
    async deleteEmployee() {
      const config = {
        title: "¿Estás seguro?",
        text:
          "Al eliminar no se podrá recuperar el proceso después y se eliminarán todos los empleados así como las relaciones.",
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#de5b5b",
        confirmButtonText: "Sí, eliminar",
      };
      await this.$swal(config).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const deleteAttached = this.$fire.deleteFolderAttached(
              this.params.value
            );
            if (!deleteAttached) {
              await this.$store.dispatch("notify", {
                message: "Error al eliminar los anexos.",
                type: "is-danger",
                duration: 4000,
                position: "top-center",
              });
            } else {
              const result = await apiServices.delete(
                `/proceso/${this.params.value}`
              );
              if (result.data) {
                if (result.data.message === "eliminar relaciones") {
                  await this.$swal({
                    text:
                      "Error al eliminar el proceso. Debe eliminar primero las relaciones",
                    icon: "error",
                    showConfirmButton: false,
                    timer: 1700,
                  });
                } else {
                  await this.$swal({
                    text: "Proceso eliminado correctamente.",
                    icon: "success",
                    showConfirmButton: false,
                    timer: 1700,
                  });
                  this.params.api.applyTransaction({
                    remove: [this.params.node.data],
                  });
                  this.$emit("getEmployees");
                }
              }
            }
          } catch (err) {
            await this.$swal({
              text: "Error al eliminar el proceso.",
              icon: "error",
              showConfirmButton: false,
              timer: 1700,
            });
            console.log(err);
          }
        }
      });
    },
    selectedComp() {
      this.$emit("selectedComp", this.params.data);
    },
    async switchStatus() {
      try {
        const result = await apiServices.post("switchStatusProcess", {
          idProcess: this.params.data._id,
          newStatus: !this.params.data.status,
        });
        if (result.data) {
          if (this.params.data) {
            const newData = { ...this.params.data, status: result.data.status };
            this.params.node.setData(newData);
          }

          await this.$store.dispatch("notify", {
            message: `Se ha ${
              !this.params.data.status ? "habilitado" : "deshabilitado"
            } el proceso.`,
            type: "is-link",
          });
        }
      } catch (e) {
        await this.$store.dispatch("notify", {
          message: `Error al ${
            !this.params.data.status ? "Habilitar" : "Deshabilitar"
          } el proceso.`,
          type: "is-danger",
        });
      }
    },
  },
};
</script>

<style lang="scss">
.no-border {
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/lideres/components/buttonsActionProcess.vue